import { ComponentType } from '@angular/cdk/overlay';
import { WcgUploadReviewerMaterialsComponent } from '@data-access/submissions/dialogs/components/upload-reviewer-materials/upload-reviewer-materials.component';
import { createAction, props } from '@ngrx/store';
import { WcgUploadDocumentComponent, WcgUploadRequestedDocumentComponent } from "@data-access/submissions";


const openUploadDialog = createAction(
  '[Documents] Open Upload Dialog',
  props<{
    data: any;
    component: () => ComponentType<WcgUploadDocumentComponent>;
  }>(),
);
const closeUploadDialog = createAction('[Documents] Close Upload Dialog');
const openRequestedUploadDialog = createAction(
  '[Documents] Open Requested Upload Dialog',
  props<{
    data: any;
    component: () => ComponentType<WcgUploadRequestedDocumentComponent>;
  }>(),
);
const closeRequestedUploadDialog = createAction(
  '[Documents] Close Requested Upload Dialog',
);

const openReviewerMaterialsDialog = createAction(
  '[Reviewer Material Documents] Open Upload Reviewer Material Dialog',
  props<{
    data: any;
    component: () => ComponentType<WcgUploadReviewerMaterialsComponent>;
  }>(),
);
const closeReviewerMaterialsDialog = createAction(
  '[Reviewer Material Documents] Close Upload Reviewer Material Dialog',
);

export const UPLOAD_DIALOG_ACTIONS = {
  openUploadDialog,
  closeUploadDialog,
  openRequestedUploadDialog,
  closeRequestedUploadDialog,
  openReviewerMaterialsDialog,
  closeReviewerMaterialsDialog,
};
